export default "__VITE_ASSET__DzzFp97M__"